import { cookiesDomain } from '../settings';

type CookiesAttributes = {
  path: string;
  domain: string;
};

export const cookiesAttributes: CookiesAttributes = { path: '/', domain: cookiesDomain };
